<template>
  <div>
    <q-select
      v-model="unidade"
      :options="listaUnidades"
      dense
      outlined
      @filter="filterFn"
      option-label="nome"
      class="input"
      option-value="id"
      behavior="menu"
      label="Selecione a Unidade"
      label-color="grey-6"
      use-input
      input-debounce="300"
      :display-value="
        unidade?.nome?.length > 9
          ? `${unidade?.nome.substring(0, 9)}..`
          : unidade?.nome
      "
    >
      <q-tooltip v-if="unidade?.nome">
        {{ unidade?.nome }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: ["resetar", "model"],
  emits: ["enviarUnidade"],
  setup(props, { emit }) {
    const store = useStore();

    const unidade = ref(props.model);
    const listaUnidades = ref([]);

    const listarUnidades = async (val) => {
      const resposta = await store.dispatch("org/listarUnidades");
      listaUnidades.value = resposta.listaUnidades;
      store.dispatch("org/saveTodasUnidade", resposta.listaUnidades);
      const needle = val.toLowerCase();
      listaUnidades.value = listaUnidades.value.filter(
        (v) => v.nome.toLowerCase().indexOf(needle) > -1
      );
    };

    watch(
      () => unidade.value,
      () => {
        emit("enviarUnidade", unidade.value);
      }
    );

    watch(
      () => props.resetar,
      () => {
        unidade.value = "";
      }
    );

    watch(
      () => props.model,
      () => {
        if (unidade.value?.id == props.model?.id) {
          return;
        }
        unidade.value = props.model;
      }
    );

    onMounted(() => {
      if (
        props.model != "" &&
        props.model != undefined &&
        props.model != null
      ) {
        emit("enviarUnidade", unidade.value);
      }
    });

    return {
      unidade,
      listarUnidades,
      listaUnidades,
      filterFn(val, update) {
        listarUnidades(val);
        setTimeout(() => {
          update();
        }, 300);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input {
    font-size: 12px;
  }
}
</style>
